import React, { useState, useEffect } from 'react';
import { Utensils, Lock, AlertTriangle } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';
import { Card, CardContent } from '@/components/ui/card';
import { ladditionAPI } from '@/lib/api';
import LadditionTab from './sales/LadditionTab';
import MyFoodFinancialTab from './sales/MyFoodFinancialTab';

const frDate = (iso) => new Date(`${iso}T12:00:00`).toLocaleDateString('fr-FR', { weekday: 'short', day: '2-digit', month: '2-digit' });

export default function MyFoodSalesPage() {
    const { user, hasPermission } = useAuth();
    const isLegacy = user && ['eeginer', 'ddultheo'].includes(user.username);
    const canProducts = hasPermission('sales_myfood_view') || isLegacy;
    const canFinancial = hasPermission('sales_myfood_financial_view') || isLegacy;
    const allowed = canProducts || canFinancial;
    const tabs = [
        ...(canProducts ? [['reports', 'Produits']] : []),
        ...(canFinancial ? [['financial', 'Financier']] : []),
    ];
    const [tab, setTab] = useState(canProducts ? 'reports' : 'financial');
    const [missingZ, setMissingZ] = useState([]);
    useEffect(() => {
        if (!allowed) return;
        ladditionAPI.zAlert().then(r => setMissingZ(r.data?.missing_dates || [])).catch(() => {});
    }, [allowed]);
    if (user && !allowed) {
        return (
            <Card><CardContent className="py-14 text-center text-slate-400" data-testid="myfood-restricted">
                <Lock className="w-8 h-8 mx-auto mb-3 text-slate-300" />
                Accès réservé.
            </CardContent></Card>
        );
    }
    return (
        <div className="space-y-4 animate-fade-in" data-testid="myfood-sales-page">
            <div className="flex flex-wrap items-center gap-3">
                <Utensils className="w-6 h-6 text-rose-500" />
                <h1 className="text-2xl font-bold text-slate-900">Ventes My Food</h1>
                <span className="text-sm text-slate-500">Caisse L'Addition — rapports Z quotidiens</span>
                <div className="ml-auto inline-flex bg-slate-200 rounded-md p-0.5 text-xs gap-0.5">
                    {tabs.map(([id, lbl]) => (
                        <button key={id} type="button" onClick={() => setTab(id)}
                            className={`px-3 py-1 rounded font-semibold transition-all ${tab === id ? 'bg-slate-900 text-white shadow' : 'text-slate-600 hover:text-slate-900'}`}
                            data-testid={`myfood-tab-${id}`}
                        >{lbl}</button>
                    ))}
                </div>
            </div>
            {missingZ.length > 0 && (
                <div className="flex items-start gap-3 rounded-lg border-2 border-amber-400 bg-amber-50 px-4 py-3" data-testid="z-missing-banner">
                    <AlertTriangle className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" />
                    <div className="text-sm text-amber-900">
                        <p className="font-bold">Rapport{missingZ.length > 1 ? 's' : ''} Z manquant{missingZ.length > 1 ? 's' : ''} : {missingZ.map(frDate).join(', ')}</p>
                        <p className="mt-0.5">Aucun email Z reçu pour ce{missingZ.length > 1 ? 's' : 'tte'} journée{missingZ.length > 1 ? 's' : ''}. Vérifiez sur la caisse : <b>Paramètres → Poste → Gestion de caisse → « Email rapports »</b> puis <b>Save and Upload</b>.
                            <span className="text-amber-700"> Les liens de détail Dood/Easy expirent 24 h après l'envoi de l'email.</span></p>
                    </div>
                </div>
            )}
            {tab === 'reports' ? <LadditionTab /> : <MyFoodFinancialTab />}
        </div>
    );
}
